module.exports = __webpack_public_path__ + "static/media/icon-to-detail.012bde40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-to-detail.svg
// module id = 1610
// module chunks = 0